<template>
    <section>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters">
                <el-form-item>
                    <el-input v-model="filters.masterId" placeholder="工程师ID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="filters.state" clearable placeholder="请选择">
                        <el-option
                                v-for="item in applyCashType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                            v-model="date"
                            type="datetimerange"
                            :picker-options="pickerOptions"
                            placeholder="选择日期时间"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-on:click="getApplyCashes">查询</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <el-table :data="applyCashes" highlight-current-row border stripe v-loading="listLoading"
                  @selection-change="selsChange"
                  style="width: 100%;text-align: center">
            <el-table-column type="index" width="60">
            </el-table-column>
            <el-table-column prop="orderNOs" label="订单编号" width="140">
            </el-table-column>
            <el-table-column prop="masterId" label="工程师ID" width="140">
            </el-table-column>
            <el-table-column prop="masterName" label="姓名" width="140">
            </el-table-column>
            <el-table-column prop="masterPhone" label="联系方式" width="140">
            </el-table-column>
            <el-table-column prop="applyTime" label="申请时间" width="170">
            </el-table-column>
            <el-table-column prop="handleTime" label="处理时间" width="170">
            </el-table-column>
            <el-table-column prop="money" label="提现金额" width="100" :formatter="formatMoney">
            </el-table-column>
            <el-table-column prop="state" label="状态" width="100" :formatter="formatStatus">
            </el-table-column>
            <el-table-column prop="remark" label="备注">
            </el-table-column>


            <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                    <el-button type="primary" size="small" @click="edit(scope.$index, scope.row)">审核</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>-->
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="rowCount"
                           :total="total" style="float:right;">
            </el-pagination>
        </el-col>

        <!--审核界面-->
        <el-dialog title="审核" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="120px" ref="editForm">
                <el-form-item label="状态">
                    <el-switch
                            v-model="editForm.state"
                            on-text="同意"
                            off-text="拒绝">
                    </el-switch>
                </el-form-item>

                <el-form-item label="备注">
                    <el-input type="textarea" :rows="4" v-model="editForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>

    </section>
</template>

<script>
    import util from '../../common/js/util'
    import NProgress from 'nprogress'
    import {requestPost} from '../../api/api';
    import {data} from "../../common/data";

    export default {
        data() {
            return {
                filters: {
                    masterId:'',
                    state: '',
                    startTime: '',
                    endTime: ''
                },
                pickerOptions: data.pickerOPtions,
                date: '',
                applyCashes: [],
                total: 0,
                rowCount: 20,
                pageNO: 1,
                applyCashType: data.applyCashType,
                listLoading: false,
                sels: [],

                editFormVisible: false,
                editLoading: false,
                editForm: {
                    applyCashId: '',
                    state: false,
                    remark: ''

                }

            }
        },
        methods: {
            formatMoney: function (row, column) {
                return row.money / 100;
            },

            formatStatus: function (row, column) {
                switch (parseInt(row.state)) {
                    case 0:
                        return '未处理';
                    case 1:
                        return '同意';
                    case 2:
                        return '拒绝';
                    default:
                        '未知类型';
                }

            },

            handleCurrentChange(val) {
                this.pageNO = val;
                this.getApplyCashes();
            },

            getApplyCashes() {

                let para = {
                    rowCount: this.rowCount,
                    pageNO: this.pageNO
                };

                console.log(this.date[0]);

                if (this.date[0]) {
                    this.filters.startTime = util.formatDate.format(new Date(this.date[0]), 'yyyy-MM-dd hh:mm:ss');
                    this.filters.endTime = util.formatDate.format(new Date(this.date[1]), 'yyyy-MM-dd hh:mm:ss');
                } else {
                    this.filters.startTime = '';
                    this.filters.endTime = '';
                }
                Object.assign(para, this.filters);
                this.listLoading = true;
                NProgress.start();
                let url = 'applyCash/queryPage.do';
                requestPost(this, url, para).then((res) => {

                    if (res != '') {
                        this.total = res.total;
                        this.applyCashes = res.data;
                    }
                    this.listLoading = false;
                    NProgress.done();
                });
            },
            //删除
            del: function (index, row) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.listLoading = true;
                    NProgress.start();
                    let para = {applyCashId: row.applyCashId};
                    let url = 'applyCash/del.do';
                    requestPost(this, url, para).then((res) => {
                        this.listLoading = false;
                        NProgress.done();
                        if (res != '') {
                            this.filters.applyCashType = row.applyCashType;
                            util.successTip(this);
                            this.getApplyCashes();
                        }
                    });
                }).catch(() => {

                });
            },
            //显示编辑界面
            edit: function (index, row) {
                this.editFormVisible = true;
                this.editForm.applyCashId = row.applyCashId;
            },
            //显示新增界面
            handleAdd: function () {
                this.addFormVisible = true;
            },

            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.editLoading = true;
                            NProgress.start();
                            let para = Object.assign({}, this.editForm);
                            if (para.state) {
                                para.state = 1;

                            } else if (!para.state) {
                                para.state = 2;
                            }
                            let url = 'applyCash/handle.do';
                            requestPost(this, url, para).then((res) => {
                                this.editLoading = false;
                                NProgress.done();
                                if (res != '') {
                                    util.successTip(this);
                                    this.$refs['editForm'].resetFields();
                                    this.editFormVisible = false;
                                    this.getApplyCashes();
                                }

                            });
                        });
                    }
                });
            },

            addSubmit: function () {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.addLoading = true;
                            NProgress.start();
                            let para = Object.assign({}, this.addForm);
                            let url = 'applyCash/add.do';
                            //para.birth = (!para.birth || para.birth == '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
                            requestPost(this, url, para).then((res) => {
                                this.addLoading = false;
                                NProgress.done();
                                if (res !== '') {
                                    util.successTip(this);
                                    this.$refs['addForm'].resetFields();
                                    this.addFormVisible = false;
                                    this.filters.applyCashType = this.addForm.applyCashType;
                                    this.getApplyCashes();
                                }
                            });
                        });
                    }
                });
            },

            selsChange: function (sels) {
                this.sels = sels;
            }

        },
        mounted() {
            this.getApplyCashes();
        },
        activated: function () {

        }
    }

</script>


<style scope lang="scss" type="text/scss">
    @import '../../styles/vars.scss';
</style>


// WEBPACK FOOTER //
// applyCashManage.vue?725ff9de